export const INVITATION_ACCEPTANCE_SESSION_KEY = 'graftcode:invitation-accepted'
export const SWITCH_ACCOUNT_RETURN_TO_SESSION_KEY = 'graftcode:invitation-switch-account-return-to'

export const INVITATION_OUTCOME_INVITED = 'Invited'
export const INVITATION_OUTCOME_ACCEPTED = 'Accepted'
export const INVITATION_OUTCOME_ALREADY_ACCEPTED = 'AlreadyAccepted'
export const INVITATION_OUTCOME_ALREADY_INVITED = 'AlreadyInvited'
export const INVITATION_OUTCOME_ALREADY_MEMBER = 'AlreadyMember'
export const INVITATION_OUTCOME_WRONG_ACCOUNT = 'WrongAccount'
export const INVITATION_OUTCOME_EMAIL_UNVERIFIED = 'EmailUnverified'
export const INVITATION_OUTCOME_INVALID_LINK = 'InvalidLink'
export const INVITATION_OUTCOME_REVOKED = 'Revoked'

export const InviteSendOutcomeKind = {
  Success: 'success',
  Informational: 'informational',
  Conflict: 'conflict',
  Failure: 'failure',
} as const

export type InviteSendOutcomeKind = (typeof InviteSendOutcomeKind)[keyof typeof InviteSendOutcomeKind]
